var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 133,
    viewBox: "0 0 172 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 96.9168C68 84.1179 78.3755 73.7424 91.1744 73.7424C103.973 73.7424 114.349 84.1179 114.349 96.9168H108.555C108.555 87.3177 100.774 79.536 91.1744 79.536C81.5752 79.536 73.7936 87.3177 73.7936 96.9168H68ZM91.1744 70.8456C81.5715 70.8456 73.7936 63.0677 73.7936 53.4648C73.7936 43.8619 81.5715 36.084 91.1744 36.084C100.777 36.084 108.555 43.8619 108.555 53.4648C108.555 63.0677 100.777 70.8456 91.1744 70.8456ZM91.1744 65.052C97.5763 65.052 102.762 59.8667 102.762 53.4648C102.762 47.0629 97.5763 41.8776 91.1744 41.8776C84.7725 41.8776 79.5872 47.0629 79.5872 53.4648C79.5872 59.8667 84.7725 65.052 91.1744 65.052Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 69.5,
    r: 44.5,
    stroke: "white",
    strokeWidth: 4.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvg);
export default __webpack_public_path__ + "static/media/login_svg.cbecbb676ad76588a71201d57e878a88.svg";
export { ForwardRef as ReactComponent };